// extracted by mini-css-extract-plugin
export default {"headerBarWrapper":"headerpanel_headerBarWrapper__87eFY","title":"headerpanel_title__auqpx","subTitle":"headerpanel_subTitle__bYzjj"};